import React, { useState } from 'react';
import MDButton from 'components/MDButton';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { useAppServices, useUploadImage, useUploadImages } from 'hook/services';
import Multiselect from './components/Multiselect';
import { Button, Stack } from '@mui/material';
import Editor from 'components/editor'

const EditModal = ({ data, handleRefresh, apps, category }) => {
  const AppService = useAppServices();
  const [openEditProduct, setOpenEditProduct] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [svgIcon, setSvgIcon] = useState(null);
  const [description, setDescription] = useState(data.description)
  const uploadImage = useUploadImage()
  const uploadImage2 = useUploadImages()

  const handleModal = () => {
    setOpenEditProduct(true);
  };

  const closeEditProduct = () => {
    setOpenEditProduct(false);
  };

  const handleSvgUpload = (e) => {
    setSvgIcon(e.target.files[0]);
  };

  const catOptions = category?.map(item => ({
    label: item?.name,
    value: item?._id,
  }))

  const appOptions = apps?.map(item => ({
    label: item?.name,
    value: item?.app_id,
  }))



  const handleSubmit = async (e) => {

    e.preventDefault();
    setProcessing(true);
    let image_response;
    let image_responses;

    if (e.target?.image?.files?.[0]) {
      image_response = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      });
    }

    if (e.target?.company_logo?.files?.[0]) {
      image_responses = await uploadImage2({
        file: e.target?.company_logo?.files?.[0],
        desiredPath: `app/logo/image`,
      });
    }



    const payload = {
      _id: data._id,
      name: e.target.name.value,
      company: e.target.company.value,
      award: e.target.award?.value ? JSON.parse(e.target.award.value) : [],
      description,
      facebook: e.target.facebook.value,
      image: image_response?.response.data || data.image || '',
      company_logo: image_responses?.response.data || data.company_logo || '',
    };

    console.log(payload, "payload");



    const { response } = await AppService.Players.update({ payload });

    if (response) {
      setProcessing(false);
      closeEditProduct();
      handleRefresh();
    }
  };




  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} encType="multipart/form-data">
            <MDTypography variant="h5" mb={2}>
              Edit Player
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '12px', fontWeight: '500' }} mb={1}>
                Award
              </MDTypography>
              <Multiselect data={catOptions} isMulti={true} name="award" edit_data={data?.award} />
            </MDBox>


            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} data={description} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Company</MDTypography>
              <MDInput label="Company" name="company" fullWidth defaultValue={data.company} />
            </MDBox>





            <MDBox mb={2}>
              <MDTypography variant="button">Facebook Link</MDTypography>
              <MDInput label="facebook" name="facebook" fullWidth defaultValue={data.facebook} />
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }} fullWidth>
                Upload Profile Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>


            <Stack direction="row" alignItems="center" spacing={2} style={{ marginTop: 10 }}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }} fullWidth>
                Upload Company Logo +
                <input hidden name="company_logo" type="file" />
              </Button>
            </Stack>



            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default EditModal;
